import { FieldInputProps, FieldMetaProps, FastField, Field } from "formik";

import { TextFieldProps } from "@material-ui/core";

import FormTextField from "./FormTextField";

export default function FormikTextField({
  name,
  shouldUpdate,
  fast,
  overrideFormikProps,
  ...childProps
}: TextFieldProps & {
  name: string;
  shouldUpdate?: (props: any, prevProps: any) => boolean;
  fast?: boolean;
  overrideFormikProps?: (
    field: FieldInputProps<unknown>,
    meta: FieldMetaProps<unknown>
  ) => FieldInputProps<unknown>;
}): JSX.Element {
  const Component = fast ? FastField : Field;
  return (
    <Component name={name} shouldUpdate={shouldUpdate}>
      {({
        field,
        meta
      }: {
        field: FieldInputProps<unknown>;
        meta: FieldMetaProps<unknown>;
      }) => (
        <FormTextField
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && Boolean(meta.error) ? meta.error : null}
          {...(overrideFormikProps ? overrideFormikProps(field, meta) : field)}
          {...childProps}
        />
      )}
    </Component>
  );
}
